import { render, staticRenderFns } from "./GridOrListToggle.vue?vue&type=template&id=5b6d1deb&scoped=true&"
import script from "./GridOrListToggle.vue?vue&type=script&lang=js&"
export * from "./GridOrListToggle.vue?vue&type=script&lang=js&"
import style0 from "./GridOrListToggle.vue?vue&type=style&index=0&id=5b6d1deb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d1deb",
  null
  
)

export default component.exports